import * as THREE from "three";
import { AssetManager, AudioAssetMap } from "./AssetManager";
import { LollipopHelper } from "./lollipop-helper";



export class EngineAudio extends THREE.Group {

    private _engineKeys: (keyof typeof AudioAssetMap)[] = [
        'engine-25-loop',
        'engine-25-to-100-transition',
        'engine-25-to-0-transition',
        'engine-100-loop',
        'engine-100-to-0-transition',
        'engine-100-to-25-transition',
        'engine-start-to-25-transition',
        'engine-emergency-stop',
        'lid-close',
        'lid-open',
      ];
  private _engineAudioSources: Map<keyof typeof AudioAssetMap, THREE.PositionalAudio> = new Map();

  private _baseAudioSettings = {
    volume: 0.75,
    refDistance: 1,
    rolloffFactor: 1,
    maxDistance: 100
  }

  private _currentAudio: keyof typeof AudioAssetMap | undefined = undefined;

  onAudioPlayed: (audioKey: keyof typeof AudioAssetMap) => void = () => {};


  constructor(audioListener: THREE.AudioListener, assetmanager: AssetManager) {
    super();



    for (const key of this._engineKeys) {
      const audio = assetmanager.getAudioAsset(key);
      if (audio) {
        const positionalAudio = new THREE.PositionalAudio(audioListener);
        positionalAudio.setVolume(this._baseAudioSettings.volume);
        positionalAudio.setRefDistance(this._baseAudioSettings.refDistance);
        positionalAudio.setRolloffFactor(this._baseAudioSettings.rolloffFactor);
        positionalAudio.setMaxDistance(this._baseAudioSettings.maxDistance);
        positionalAudio.setBuffer(audio);
        positionalAudio.onEnded = () => {
          this.onAudioPlayed(key);
        };

        switch (key) {
            case 'engine-25-loop':
                positionalAudio.setLoop(true);
                break;
            case 'engine-100-loop':
                positionalAudio.setLoop(true);
                break;
        }

        this._engineAudioSources.set(key, positionalAudio);
        // positionalAudio.play();
      } else {
        console.warn(`Failed to load audio asset: ${key}`)
      }
    }

    // const markerCube = new THREE.Mesh(new THREE.BoxGeometry(0.1, 0.1, 0.1), new THREE.MeshBasicMaterial({color: 0xff0000}));
    // this.add(markerCube);
    // this.add(new LollipopHelper())

    // console.log('✅ Engine audio sources loaded successfully')

  }

  playAudio(audioKey: keyof typeof AudioAssetMap) {
    if (this._currentAudio) {
      this._engineAudioSources.get(this._currentAudio)?.stop();
    }
    this._currentAudio = audioKey;
    this._engineAudioSources.get(audioKey)?.play();
  }

  getAudioDuration(audioKey: keyof typeof AudioAssetMap) {
    const audio = this._engineAudioSources.get(audioKey);
    const buffer = audio?.buffer;
    if (buffer) {
      return buffer.duration;
    }
    return 0;
  }

  stopAudio() {
    for (const source of this._engineAudioSources.values()) {
      if (source.isPlaying) {
        source.stop();
      }
    }
    this._currentAudio = undefined;
  }
}
